import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";

// import ForgotPassword from "../screens/ForgotPassword";
import { HostpitalHeader } from "../screens/HeaderAndFooter/HostpitalHeader";
import { DoctorList } from "../screens/Hospital/DoctorList";
import { AddDoctor } from "../screens/Hospital/AddDoctor";
import WebSiteHeader from "../screens/HeaderAndFooter/WebSiteHeader";
import PrivateRoutes from "./PrivateRoutes";
import Login from "../screens/NoAuthScreens/Login";
import { BlockedDoctors } from "../screens/Hospital/BlockedDoctors";
import RequireAuth from "../customJS/RequireAuth";
import Home from "../screens/NoAuthScreens/Home";
import Error404 from "../screens/NoAuthScreens/Error404";
import Signin from "../screens/NoAuthScreens/Signin";
import AdminHeader from "../screens/HeaderAndFooter/AdminHeader";
import NewRequest from "../screens/Admin/NewRequest";
import HospitalList from "../screens/Admin/HospitalList";
import ChangePassword from "../screens/NoAuthScreens/ChangePassword";
import ResetPassword from "../screens/NoAuthScreens/ResetPassword";
import YourDoctors from "../screens/NoAuthScreens/YourDoctors";
import DoctorProfile from "../screens/NoAuthScreens/DoctorProfile";
import ViewHospitalProfile from "../screens/Hospital/ViewHospitalProfile";

export const NavigationRoutes = () => {
  // const[isAuthId, setIsAuthId ] = useState(getAuthId());

  return (
    <>
      <Routes>
        <Route path="/*" exact element={<WebSiteHeader />}>
          <Route index element={<Home />} />
          <Route path="login" exact element={<Login />} />
          <Route path="changePassword" exact element={<ChangePassword />} />
          <Route path="United/changePassword" exact element={<ChangePassword />} />
          <Route path="resetPassword" exact element={<ResetPassword />} />
          <Route path="home" exact element={<Home />} />
          {/* <Route path="/" exact element={<Home />} /> */}
          <Route path="yourDoctors" exact element={<YourDoctors />} />
          <Route
            path="doctorProfile/:doctorname"
            exact
            element={<DoctorProfile />}
          />
          <Route
            path="United/doctorProfile/:doctorname"
            exact
            element={<DoctorProfile />}
          />
          <Route path="signup" exact element={<Signin />} />
          {/* <Route path="*" exact element={<Error404 />} /> */}
          <Route path="*" exact element={<Home />} />
        </Route>
        <Route element={<PrivateRoutes />}>
          <Route element={<RequireAuth allowedRoles={["2"]} />}>
            <Route path="/clinic/*" element={<HostpitalHeader />}>
              <Route path="providers" element={<DoctorList />} />
              <Route path="blockedProviders" element={<BlockedDoctors />} />
              <Route path="addProvider" element={<AddDoctor />} />
              <Route path="editDoctor" element={<AddDoctor />} />
              <Route path="viewProfile" element={<ViewHospitalProfile />} />
              <Route path="*" exact element={<Error404 />} />
            </Route>
          </Route>
          <Route element={<RequireAuth allowedRoles={["1"]} />}>
            <Route path="/admin/*" element={<AdminHeader />}>
              <Route path="providers" exact element={<DoctorList />} />
              <Route path="clinicsList" exact element={<HospitalList />} />
              <Route path="newRequest" exact element={<NewRequest />} />
              <Route
                path="blockedProviders"
                exact
                element={<BlockedDoctors />}
              />
              <Route path="viewHospital" element={<ViewHospitalProfile />} />
              <Route path="addClinic" element={<ViewHospitalProfile />} />
              <Route path="addProvider" element={<AddDoctor />} />
              <Route path="editDoctor" element={<AddDoctor />} />
              <Route path="*" exact element={<Error404 />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </>
  );
};
